export default "__VITE_ASSET__EjhXA7iv__"